/*
 * Copyright (c) 2021. Sanish Manandhar
 * All Rights Reserved
 */

import {
  COUPONS_CLEAN_REQUEST,
  COUPONS_LIST_FETCH_REQUEST,
  COUPONS_LIST_FETCH_REQUEST_SUCCESS,
  COUPONS_LIST_FETCH_REQUEST_FAILURE,
  GENERATE_DISCOUNT_CODE_REQUEST,
  GENERATE_DISCOUNT_CODE_REQUEST_FAILURE,
  GENERATE_DISCOUNT_CODE_REQUEST_SUCCESS,
  DISCOUNT_CODE_CLEAN_REQUEST,
  DISCOUNT_TYPE_FETCH_REQUEST,
  DISCOUNT_TYPE_FETCH_REQUEST_SUCCESS,
  DISCOUNT_TYPE_FETCH_REQUEST_FAILURE,
  COUPON_UPSERT_REQUEST,
  COUPON_UPSERT_REQUEST_SUCCESS,
  COUPON_UPSERT_REQUEST_FAILURE,
  SINGLE_COUPON_FETCH_REQUEST,
  SINGLE_COUPON_FETCH_REQUEST_SUCCESS,
  SINGLE_COUPON_FETCH_REQUEST_FAILURE,
  SINGLE_COUPON_CLEAN_REQUEST,
  DISCOUNT_CALCULATION_REQUEST,
  DISCOUNT_CALCULATION_REQUEST_SUCCESS,
  DISCOUNT_CALCULATION_REQUEST_FAILURE,
  CLEAN_DISCOUNT_CALCULATION_PROPS,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  newDiscountCode: [],
  newDiscountCodeLoading: false,
  newDiscountCodeErrors: {},
  discountType: [],
  discountTypeLoading: false,
  discountTypeErrors: {},
  singleCoupon: [],
  singleCouponLoading: false,
  singleCouponErrors: {},
  discountedAmount: [],
  discountedAmountLoading: false,
  discountedAmountErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const couponsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case COUPON_UPSERT_REQUEST:
    case COUPONS_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case COUPON_UPSERT_REQUEST_SUCCESS:
    case COUPONS_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case COUPON_UPSERT_REQUEST_FAILURE:
    case COUPONS_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case GENERATE_DISCOUNT_CODE_REQUEST:
      return Object.assign({}, state, {
        newDiscountCodeLoading: true,
      });

    case GENERATE_DISCOUNT_CODE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        newDiscountCodeLoading: false,
        newDiscountCode: action.data,
        newDiscountCodeErrors: {},
      });

    case GENERATE_DISCOUNT_CODE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        newDiscountCodeLoading: false,
        newDiscountCodeErrors: action.error,
      });

    case DISCOUNT_TYPE_FETCH_REQUEST:
      return Object.assign({}, state, {
        discountTypeLoading: true,
      });

    case DISCOUNT_TYPE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        discountTypeLoading: false,
        discountType: action.data,
        discountTypeErrors: {},
      });

    case DISCOUNT_TYPE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        discountTypeLoading: false,
        discountTypeErrors: action.error,
      });

    case SINGLE_COUPON_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleCouponLoading: true,
      });

    case SINGLE_COUPON_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleCouponLoading: false,
        singleCoupon: action.data,
        singleCouponErrors: {},
      });

    case SINGLE_COUPON_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleCouponLoading: false,
        singleCouponErrors: action.error,
      });

    case DISCOUNT_CALCULATION_REQUEST:
      return Object.assign({}, state, {
        discountedAmountLoading: true,
      });

    case DISCOUNT_CALCULATION_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        discountedAmountLoading: false,
        discountedAmount: action.data,
        discountedAmountErrors: {},
      });

    case DISCOUNT_CALCULATION_REQUEST_FAILURE:
      return Object.assign({}, state, {
        discountedAmountLoading: false,
        discountedAmountErrors: action.error,
      });

    case DISCOUNT_CODE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        newDiscountCode: [],
        newDiscountCodeLoading: false,
        newDiscountCodeErrors: {},
      });

    case COUPONS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    case SINGLE_COUPON_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singleCoupon: [],
        singleCouponLoading: false,
        singleCouponErrors: {},
      });

    case CLEAN_DISCOUNT_CALCULATION_PROPS:
      return Object.assign({}, state, {
        discountedAmount: [],
        discountedAmountLoading: false,
        discountedAmountErrors: {},
      });

    default:
      return state;
  }
};

export default couponsReducer;
